var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72005 5.28302L9.38067 4.92579C9.37492 4.91973 9.36629 4.91771 9.35862 4.91065L4.97541 0.295926C4.60056 -0.0986419 3.9937 -0.0986419 3.6198 0.295926L3.28042 0.652147C2.90653 1.04671 2.90653 1.68549 3.28042 2.07905L7.00499 6.0005L3.28042 9.92095C2.90653 10.3145 2.90653 10.9543 3.28042 11.3489L3.6198 11.7041C3.9937 12.0986 4.60056 12.0986 4.97541 11.7041L9.35862 7.09036C9.36533 7.0833 9.37492 7.08128 9.38067 7.07421L9.72005 6.71799C9.90796 6.5202 10.001 6.25985 9.99999 6.0005C10.001 5.74015 9.90796 5.48081 9.72005 5.28302Z",
    fill: "#6D6D72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.edef90c16d306c837d4a8afc3c26a7a1.svg";
export { ForwardRef as ReactComponent };